import { Box, chakra, Heading, Stack, Text } from '@chakra-ui/react';
import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import React from 'react';
import { IChildren} from 'Types/Interface/Sanity';
import { useTermsOfServiceBrandsLocalization} from 'Utils/localizationHooks';


export const TermsOfServiceJumbotronSection = () => {

	return(
		<Stack 
			py={['70px','0px']} 
			spacing={10} 
			textAlign={['left','left']} 
			justifyContent={'center'} 
			alignItems={['start','start']}
			h={'50vh'}
		>
			<Heading fontWeight={'bold'} fontSize={{ base: '40px', tablet: '2xl', xxl: '50px' }} w={'100%'}>
				Terms and Conditions
			</Heading>
			<Text w={['', '700px']} fontSize={['16px','16px']}>
				<chakra.span fontWeight={'bold'}>Effective Date of this Current Policy:</chakra.span> January 24, 2025
			</Text>
			
		</Stack>
	);
};

export const TermsOfServiceBrands = () => {
	const { localization: BrandstermsLocalization } = useTermsOfServiceBrandsLocalization();

	return(
		<LandingPageLayout isBusiness JumbotronSection={<TermsOfServiceJumbotronSection />} >
			<Stack spacing={6} pt={12}>
						
				{  BrandstermsLocalization?.termsOfServiceBrands?.map((term) => (
					<Box key={term._key}>
						<Text  fontSize="14px" fontWeight={500} color="#121B26">
							{term.children.map((child:IChildren) =>
								child.marks.includes('strong') ? (
								<strong key={child._key}>{child.text}</strong>
								) : (
								<span key={child._key}>{child.text}</span>
								)
							)}
						</Text>
					</Box>
				)) }
			</Stack>
		</LandingPageLayout>
	);
};